import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { addPagingGroup } from "../../../apiclients/streamsapi_bridge";
import { useLocation, useNavigate } from "react-router";
import {
    MDBBtn,
    MDBModalFooter,
    MDBSpinner,
} from "mdb-react-ui-kit";

function AddPagingPopup(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [pagingForm, setPagingForm] = useState({ groupname: '', groupno: '' });
    const [isError, setError] = useState("");
    const [groupNameError, setGroupNameError] = useState("");
    const [isloading, setIsloading] = useState(false);

    const existingGroupList = [];

    props.accountPagingGroups.forEach(group => {
        existingGroupList.push(group.groupno);
    });

    const [existedNumbers, setExistedNumbers] = useState(existingGroupList);

    const missNumber = findMissingNumber(existedNumbers);
    const [Newgroupno, setNewgroupno] = useState(missNumber);

    function findMissingNumber(existedNumbers) {
        console.log("existedNumbers :" + JSON.stringify(existedNumbers))
        for (let i = 1; i <= 25; i++) {
            if (!existedNumbers.includes(i)) {
                return i;
            }
        }
        return 0;
    }


    const handleGroupnoInputValidation = (inputGrpno) => {
        console.log("User inputGrpno :" + inputGrpno);
        setNewgroupno(inputGrpno);
        if (inputGrpno === "") {
            setError("Group ID should not be empty"); // If inputGrpno is empty, do not set error
        } else if (existedNumbers.includes(Number(inputGrpno))) {
            setError("Group ID already exists"); // Set error if inputGrpno exists in existedNumbers
        } else if (inputGrpno > 25 || inputGrpno <= 0) {
            setError('Group ID must be between 1 and 25');
        } else {
            setError("");
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        console.log("Event ::::::::::" + event.target.value);
        console.log("name ::::::::::" + event.target.name);

        if (event.target.value.trim() == "") {
            setGroupNameError("Group Name should not be empty");
        }
        else if (name === "groupname" &&
            props.accountPagingGroups.some(group => group.groupname.toLowerCase() === value.trim().toLowerCase())
        ) {
            setGroupNameError("Paging Group Name already exists");
        } else {
            setGroupNameError("");
        }

        setPagingForm((prevFormData) => ({ ...prevFormData, [name]: value }));
        console.dir(event);
    }

    const savePagingGroup = async () => {
        setIsloading(true)

        console.log("Add Paging Group :::::", Newgroupno);
        console.log("User Entered :" + JSON.stringify(pagingForm));

        // Check if the group name is empty
        if (pagingForm.groupname.trim() === "") {
            setGroupNameError("Group Name should not be empty");
            setIsloading(false)
            return;  // Stop the submission
        }

        if(Newgroupno > 25 || Newgroupno <= 0){
            setError('Group ID must be between 1 and 25');
            setIsloading(false)
            return
        }

        // Check if the group name already exists
        const isDuplicateGroupName = props.accountPagingGroups.some(
            group => group.groupname.toLowerCase() === pagingForm.groupname.trim().toLowerCase()
        );

        if (isDuplicateGroupName) {
            setGroupNameError("Paging Group Name already exists");
            return;
        }
        if (Newgroupno === "" || Newgroupno === null) {
            setError("Group ID should not be empty");
            return;
        }

        let params = { ...pagingForm, groupno: Newgroupno };
        params.siteid = JSON.parse(sessionStorage.getItem('admin_session')).siteid;
        console.log("Request Data: " + JSON.stringify(params));

        const serverResponse = await addPagingGroup(params.siteid, params);
        const response = await serverResponse.json()

        if (!serverResponse.ok) {
            if (serverResponse.status === 409) {
                const isExist = response.isExist;

                switch (isExist) {
                    case 1:
                        setGroupNameError("Paging Group Name already exists");
                        break;
                    case 2:
                        setError("Group ID already exists");
                        break;
                    case 3:
                        setError("Group ID already exists");
                        setGroupNameError("Paging Group Name already exists");
                        break;
                    default:
                        // optional: handle unexpected value
                        break;
                }
            }
            console.log("Network response was not ok");
            // throw new Error('Network response was not ok');
        } else {
            console.log("API response is successful for Add request");
            props.onClose();
            navigate("/pslanding", { state: { tab: "tab3" } });
            localStorage.setItem("s_message", `Paging Group ${pagingForm.groupname} added successfully.`);
            window.location.reload();
        }
        setTimeout(()=>{
            setIsloading(false)
        },200)
    };


    return (
        <>
            <div className="tel-numbers">
                <strong>{t("PagingGroupName")}</strong>
            </div>
            <div className="form pt-1">
                <input
                    type="text"
                    name="groupname"
                    maxLength={30}
                    className="form-control"
                    //  value={pagingForm.groupname}
                    placeholder="Please enter paging Group name"
                    onChange={handleChange}
                    onKeyDown={(event) => {
                        if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }}
                //value="Backoffice"
                />
                {groupNameError && (
                    <span className="red mb-1">{groupNameError}</span>
                )}
            </div>
            <div className="tel-numbers pt-2">
                <strong>{t("GroupID")}</strong>
            </div>
            <div className="form pt-1 mb-2">
                <input
                    type="text"
                    name="groupno"
                    maxLength={10}
                    className="form-control w-100 me-3"
                    onKeyDown={(event) => {
                        if (!/[0-9]/.test(event.key) && event.key !== 'Backspace') {
                            event.preventDefault();
                        }
                    }}
                    value={Newgroupno}
                    onChange={(e) => handleGroupnoInputValidation(e.target.value)}
                />
                {isError && <span className="red mb-1">{isError}</span>}
            </div>

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn disabled={isError} onClick={savePagingGroup}>{t("add")}</MDBBtn>
            </MDBModalFooter>

             {isloading && (
                      <div>
                        <div className="loadingclass-popup"></div>
                        <div className="popup-bg-loader loader_align">
                          <MDBBtn disabled>
                            <MDBSpinner
                              size="sm"
                              role="status"
                              tag="span"
                              className="me-2"
                            />
                            Loading...
                          </MDBBtn>
                        </div>
                      </div>
                    )}

        </>
    )
}

export default AddPagingPopup;